import { render, staticRenderFns } from "./DepMana.vue?vue&type=template&id=6288a2aa"
import script from "./DepMana.vue?vue&type=script&lang=js"
export * from "./DepMana.vue?vue&type=script&lang=js"
import style0 from "./DepMana.vue?vue&type=style&index=0&id=6288a2aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports